// extracted by mini-css-extract-plugin
export default {"login":"Login_login__X1qpx","login__center":"Login_login__center__8ctiY","title":"Login_title__Ty0JO"};